export enum ErrorCode {
  None = 0,
  BadRequest = 1,
  Disallowed = 2,
  RequestClosed = 3
};

export enum Scenario {
  Unauth = 0,
  Auth = 1
};

export const defaultLocales: { [key: string]: string } = {
  cs: 'CZ',
  da: 'DK',
  de: 'DE',
  et: 'EE',
  en: 'US',
  es: 'ES',
  fr: 'FR',
  hr: 'HR',
  id: 'ID',
  it: 'IT',
  lv: 'LV',
  lt: 'LT',
  hu: 'HU',
  nl: 'NL',
  nb: 'NO',
  pl: 'PL',
  pt: 'PT',
  ro: 'RO',
  sk: 'SK',
  sl: 'SL',
  sr: 'Latn-RS',
  fi: 'FI',
  sv: 'SE',
  vi: 'VN',
  tr: 'TR',
  el: 'GR',
  bg: 'BG',
  ru: 'RU',
  uk: 'UA',
  he: 'IL',
  ar: 'AE',
  th: 'TH',
  ko: 'KR',
  zh: 'CN',
  ja: 'JP'
};

export enum ApiCallStatus {
  NotStarted,
  InProgress,
  Succeeded,
  Failed
};